import { Box } from '@mui/material'
import { styled } from '@mui/material/styles'

/**
 * Shared max-width/padding shell every numbered Landing v2 section (Fidelity,
 * Interactions, Key, Room, AlreadyShared, Proof) wraps itself in — pulled out
 * on its own so section components can live in their own files without a
 * circular import back into `LandingSections.tsx`.
 */
export const Sec = styled('section')({
  maxWidth: 1240,
  margin: '0 auto',
  padding: 'clamp(70px, 9vw, 120px) clamp(20px, 4vw, 48px) 0',
})
